<template lang="pug">
  div.mapzoom
    div.mapzoom__selector
      //- LayersSelect
        template(v-for="(option, index) in zoomOptions")
          ods-button(:slot="'option'+index" type="text" size="small" @click="zoomToScale(option.value)") {{ option.label }}
    div.mapzoom__controllers
      ods-button(icon="ods-icon-minus" plain @click="zoom(false)")
      ods-button(icon="ods-icon-plus" plain @click="zoom(true)")
    div.mapzoom__controllers
      ods-button(plain @click="zoom3D()")
        ods-icon(name="ico-2d" size="12" v-if="!z3D")
        ods-icon(name="ico-3d" size="12" v-else)
      ods-button(plain size="small" @click="setInitialZoom()")
        ods-icon(name="home" size="16")
</template>

<script>
import LayersSelect from '@/components/LayersSelect'
export default {
  name: 'ParksAndGardensDashboard',
  data () {
    return {
      zoomOptionSelect: '150',
      z3D: true,
      zoomOptions: [{
        value: '50',
        label: 'Distrito'
      },
      {
        value: '150',
        label: 'Municipio'
      }]
    }
  },
  methods: {
    zoom (zoomIn) {
      // const component = this
      if (zoomIn) {
        this.$store.dispatch('zoomIn')
      } else {
        this.$store.dispatch('zoomOut')
      }
    },
    zoom3D () {
      const component = this
      component.z3D = !component.z3D
      this.$store.dispatch('switchModeView')
    },
    zoomToScale (scale) {
      this.$store.dispatch('zoomToScale', scale)
    }
  },
  components: {
    LayersSelect
  }
}
</script>

<style lang="scss" scoped>
  .mapzoom {
    right: 31px;
    position: absolute;
    bottom: 32px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-end;
    width: 81px;
    height: auto;
    opacity: 1;
    transition: opacity 0.5s;
    &__compare {
      .ods-button {
        padding: 8px 14px;
      }
    }
    &__selector {
      position: relative;
      margin: 0;
      padding: 0;
      + .mapzoom__controllers {
        margin-top: 8px;
        margin-bottom: 8px;
      }
    }
    &__controllers {
      position: relative;
      background-color: $--color-white;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
      border-radius: 2px;
      // box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
      display: flex;
      &::after {
        content: '';
        display: block;
        position: absolute;
        margin: 10px 0;
        left: 40px;
        /* left: 6px; */
        width: 1px;
        height: 16px;
        background-color: $--color-grey-medium-2;
        pointer-events: none;
      }
      .ods-button {
        margin: 0;
        padding: 0;
        width: 40px;
        height: 36px;
        padding-top: 4px;
        border-radius: 0;
        background-color: $--color-white;
        border-radius: 2px 0 0 2px;
        border: 0;
        cursor: pointer;
        outline: 0;
        &:hover {
          background: $--color-blue-dark;
          color: $--color-white;
        }
        &:focus, &:active {
          background: $--color-white;
          color: $--color-blue-dark;
        }
        i {
          margin-left:0;
        }
        +.ods-button {
          border-radius: 0 2px 2px 0;
          margin-left: 1px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/MapZoomParksCompare.vue